(function (global) {
  var ENTITY_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return ENTITY_MAP[ch] || ch;
    });
  }

  function sanitizeQueryValue(value, maxLen) {
    if (value == null) return '';
    var text = String(value).replace(/[\u0000-\u001F\u007F]/g, '').trim();
    if (typeof maxLen === 'number' && maxLen > 0 && text.length > maxLen) {
      text = text.slice(0, maxLen);
    }
    return text;
  }

  function isSafeInternalPath(href) {
    if (!href) return false;
    if (/^(javascript|data|vbscript):/i.test(href.trim())) return false;
    try {
      var url = new URL(href, global.location.origin);
      return url.origin === global.location.origin && url.pathname.charAt(0) === '/';
    } catch (e) {
      return href.charAt(0) === '/' && href.charAt(1) !== '/';
    }
  }

  function isSafeContactPath(href) {
    if (!isSafeInternalPath(href)) return false;
    try {
      var url = new URL(href, global.location.origin);
      return url.pathname === '/pages/contact' || url.pathname.endsWith('/pages/contact');
    } catch (e2) {
      return href.indexOf('/pages/contact') > -1;
    }
  }

  global.TcbSecurity = {
    escapeHtml: escapeHtml,
    sanitizeQueryValue: sanitizeQueryValue,
    isSafeInternalPath: isSafeInternalPath,
    isSafeContactPath: isSafeContactPath
  };
})(window);
